"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _hooks = require("../hooks");

var _layout = require("../layout");

var _propTypes = require("../prop-types");

var _utils = require("../utils");

var _constants = require("./constants");

var _core = require("@emotion/core");

var _excluded = ["children", "isExpanded", "topSpacing", "id", "shouldAnimateImmediately"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ExpanderContentWithoutDocs = function ExpanderContentWithoutDocs(_ref) {
  var children = _ref.children,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? _constants.ExpanderContentDefaultProps.isExpanded : _ref$isExpanded,
      _ref$topSpacing = _ref.topSpacing,
      topSpacing = _ref$topSpacing === void 0 ? _constants.ExpanderContentDefaultProps.topSpacing : _ref$topSpacing,
      id = _ref.id,
      _ref$shouldAnimateImm = _ref.shouldAnimateImmediately,
      shouldAnimateImmediately = _ref$shouldAnimateImm === void 0 ? _constants.ExpanderContentDefaultProps.shouldAnimateImmediately : _ref$shouldAnimateImm,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(isExpanded),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isRest = _useState2[0],
      setIsRest = _useState2[1];

  var _useResizeObserver = (0, _hooks.useResizeObserver)({
    // If contentHeight isn't calculated yet, use an extremely large maxHeight to
    // prevent content shifting around once it has been calculated. The change
    // won't be visible because this is maxHeight not height, so the expander won't
    // grow bigger than the content anyway.
    defaultHeight: isExpanded ? 99999 : 0
  }),
      ref = _useResizeObserver.ref,
      contentHeight = _useResizeObserver.height;

  var transitions = (0, _reactSpring.useTransition)(isExpanded, {
    // Initial style have completed style on first render if expanded
    initial: {
      opacity: isExpanded ? 1 : 0,
      maxHeight: contentHeight
    },
    from: {
      opacity: 0,
      maxHeight: 0
    },
    enter: {
      opacity: 1,
      maxHeight: contentHeight
    },
    leave: {
      opacity: 0,
      maxHeight: 0
    },
    // Updating style if `contentHeight` will be changed
    update: {
      maxHeight: contentHeight
    },
    immediate: shouldAnimateImmediately,
    onStart: function onStart() {
      return setIsRest(false);
    },
    onRest: function onRest() {
      return setIsRest(true);
    }
  });
  return transitions(function (props, item) {
    return item && (0, _core.jsx)(_reactSpring.animated.div, (0, _extends2.default)({
      style: _objectSpread(_objectSpread({}, props), {}, {
        overflow: isRest ? 'visible' : 'hidden'
      })
    }, (0, _utils.pickDataProps)(forwardedProps)), (0, _core.jsx)("div", {
      id: id,
      "aria-hidden": !isExpanded,
      ref: ref
    }, (0, _core.jsx)(_layout.Spacer, {
      height: topSpacing
    }), children));
  });
};

var ExpanderContentWithDocs = (0, _stencilReactDesc.describe)(ExpanderContentWithoutDocs).description('Container which can be collapsed or expanded.');
ExpanderContentWithDocs.propTypes = {
  children: _stencilReactDesc.PropTypes.node.description('Content to display in the container.'),
  id: _stencilReactDesc.PropTypes.string.description("Sets the 'id' attribute in the DOM for the content."),
  isExpanded: _stencilReactDesc.PropTypes.bool.description('Whether the container should be expanded. If false, the content will not be visible.') // Normally defaults would come from defaultProps automatically but due to a
  // bug in react-desc, defaults that are falsy get ignored.
  .defaultValue(_constants.ExpanderContentDefaultProps.isExpanded),
  topSpacing: (0, _propTypes.cssValue)().description('Spacing in pixels to add above the content at the top of the container.') // Same as above
  .defaultValue(_constants.ExpanderContentDefaultProps.topSpacing)
};
var ExpanderContent = (0, _utils.withTestAttributes)({
  component: 'StencilExpanderContent'
})(ExpanderContentWithDocs);
ExpanderContent.defaultProps = _objectSpread({}, _constants.ExpanderContentDefaultProps);
ExpanderContent.displayName = 'ExpanderContent';
var _default = ExpanderContent;
exports.default = _default;